import Payoffs from './Payoffs';

export default Payoffs;
